import { General } from "../../siteManagement/general"
import { AppHelper } from "../appHelper";
import { AppBaseProps, CommonApp, Metadata } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType } from "../../siteManagement/sheet";
import { Grid } from "../core/components/grid";
import { NukreisEntity, NukreisProps, Nukreis } from "./nukreis";
import NuKreisId, { NukreisIdEntity, NuKreisIdListEntity, NuKreisIdProps } from "./nuKreisId";
import { AuArtNuKreis } from "./auArtNukreis";
import { StringKeyDictionary } from "../commonInterfaces";
import { ToolBarStandardButtonType } from "../core/components/toolBar";
import React from "react";

export default class NukreisSelection extends React.Component<NukreisSelectionProps, any>{
    common = new AppHelper();
    nukreisSelectionGridOptions: kendo.ui.GridOptions;
    auArtNukreisGridOptions: kendo.ui.GridOptions;
    private metaData: Metadata;
    private translations: StringKeyDictionary<string>

    constructor(props: NukreisSelectionProps) {
        super(props)
        this.common.init(this);
        this.state = {};
        this.initApp();
    }

    private initApp = async () => {
        let result = await Promise.all([
            Helper.getTranslations([
                "Standard.Designation", "WebCRM.Nukreis.Min", "WebCRM.Nukreis.Max",
                "WebCRM.Nukreis.Prefix", "WebCRM.Nukreis.Suffix", "Field.Auftrag.knr",
                "Projekt.Auftragsart", "Standard.Beschreibung", "WebSMS.TranslationsEditor.Key",
                "Statistik.Obergruppe", "WebCRM.Nukreis.EditNumberRanges", "WebCRM.Nukreis.NuKreis",
                "WebCRM.Nukreis.OverlapsOccured"
            ]),
            this.getMetaData()
        ]);
        this.metaData = result[1];
        this.translations = result[0].Data;

        this.setState({})
    }

    private getMetaData = () => {
        return new Promise<Metadata>(async (resolve) => {
            if (this.props.mainGroupDependent) {
                let md= await Helper.getMetaData("nukreisId")
                resolve(md);
            } else {
                let md = await Helper.getMetaData("nukreis");
                resolve(md)
            }
        })
    }

    private editNukreisId = async (dataItem: { Type: string, Name: string }) => {
        const result = await HTTPService.get<JsonResultClass<NukreisIdEntity[]>>(`Nukreis/GetNuKreisIdListByType?type=${dataItem.Type}`);
        const entity: NuKreisIdListEntity = {
            Data: result.Data,
            Type: dataItem.Type,
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            IndividualFields: null
        }
        const props: NuKreisIdProps = {
            context: {
                contextType: ""
            },
            dataSources: null,
            entity: entity,
            isWindow: false,
            metadata: this.metaData,
            title: this.translations["WebCRM.Nukreis.EditNumberRanges"].replace("{type}", dataItem.Name),
            translations: this.translations
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(NuKreisId, props);
        });
        sheet.bind(SheetEventType.Close, () => {
            this.common.updateBrowserTitle(this.props.title);
        })
    }

    private editNukreis = async (dataItem: {Type: string, Name: string}) => {
        const entity = await HTTPService.get<JsonResultClass<NukreisEntity>>(`Nukreis/GetNuKreisByType?type=${dataItem.Type}`);
        const props: NukreisProps = {
            context: {
                contextType: ""
            },
            dataSources: null,
            entity: entity.Data,
            isWindow: false,
            metadata: this.metaData,
            title: this.translations["WebCRM.Nukreis.EditNumberRanges"].replace("{type}", dataItem.Name),
            translations: this.translations
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(Nukreis, props);
        });
        sheet.bind(SheetEventType.Close, () => {
            this.common.updateBrowserTitle(this.props.title);
        })
    }

    createSelection = () => {
        if (Helper.hasValue(this.nukreisSelectionGridOptions)){
            return (
                <div className="flex-container">
                    <Grid
                        data={this.props.data}
                        options={this.nukreisSelectionGridOptions}
                        id="nukreisselection"
                        standardButtons={[{ type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Editieren"), enabled: true }]}
                        onClickStandardButton={(_, dataItem) => {
                            if (this.props.mainGroupDependent) {
                                this.editNukreisId(dataItem);
                            } else {
                                this.editNukreis(dataItem);
                            }
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    }

    createAuArt = () => {
        return (
            <>
                <AuArtNuKreis gridOptions={this.auArtNukreisGridOptions} openNuKreis={this.openAuArtNuKreis} />
            </>    
        );
        
    }

    private openAuArtNuKreis = (item) => {
        if (this.props.mainGroupDependent) {
            this.editNukreisId({ Name: item.Bezeichnung, Type: item.NuKreis  });
        } else {
            this.editNukreis({ Name: item.Bezeichnung, Type: item.NuKreis });
        }
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
        this.common.updateBrowserTitle(this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} title={this.props.title} />;
    }
}

export interface NukreisSelectionProps extends AppBaseProps {
    mainGroupDependent: boolean;
    data: any[];
}